export var RoomMessgaeType;
(function (RoomMessgaeType) {
    RoomMessgaeType[RoomMessgaeType["NewMember"] = 0] = "NewMember";
    RoomMessgaeType[RoomMessgaeType["Offer"] = 1] = "Offer";
    RoomMessgaeType[RoomMessgaeType["Answer"] = 2] = "Answer";
    RoomMessgaeType[RoomMessgaeType["IceCandidate"] = 3] = "IceCandidate";
})(RoomMessgaeType || (RoomMessgaeType = {}));
